// extracted by mini-css-extract-plugin
export default {"btn-sm-yellow":"button-disclosures_btn-sm-yellow__Ie+vK"};